export const phones = 'max-width: 576px'

export const tablets = 'max-width: 768px'
